<template>
    <li :class="{'uk-disabled tm-disabled': multipleMode && multipleModeProperty.id !== property.id}">

        <div class="uk-h4">{{ property.name }}</div>

        <div class="uk-accordion-content uk-margin-small-top uk-margin-small-bottom">
            <ul class="uk-list uk-text-small uk-padding-remove">
                <li v-for="propertyValue in propertyValues" :key="propertyValue.id">
                    <label>
                        <input @change="selectPropertyValue" v-model="checkedPropertyValues" :value="propertyValue.id"
                               class="uk-checkbox uk-margin-xsmall-right"
                               type="checkbox"> {{ propertyValue.value_varchar }}
                    </label>
                </li>
            </ul>
        </div>
        <div v-if="multipleMode === false" class="uk-text-meta uk-margin-small-top">
            <a v-if="hasNotSelected && moreThanOne" @click="turnMultipleMode">Выбрать несколько</a>

            <a v-if="checkedPropertyValues.length > 0" @click="clear" class="uk-float-right">Очистить</a>
        </div>
        <div v-else-if="multipleMode && multipleModeProperty.id === property.id"
             class="uk-text-meta uk-margin-small-top">
            <a @click="acceptMultipleMode">Применить</a>
            <a @click="cancelMultipleMode" class="uk-float-right">Отмена</a>
        </div>

    </li>
</template>

<script>
    export default {
        name: "ShopFilterRow",
        props: {
            property: {
                type: Object,
                required: true,
            },
            propertyValues: {
                type: Array,
                required: true,
            },
            multipleMode: {
                type: Boolean,
                required: true,
                default() {
                    return false
                }
            },
            multipleModeProperty: {
                type: Object,
                default() {
                    return {}
                }
            },
            selected: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        watch: {
            selected() {
                this.checkedPropertyValues = this.selected;
            }
        },
        computed: {
            hasNotSelected() {
                return this.checkedPropertyValues.length !== this.propertyValues.length
            },
            moreThanOne() {
                return this.propertyValues.length > 1
            }
        },
        data() {
            return {
                checkedPropertyValues: this.selected
            }
        },
        methods: {
            selectPropertyValue() {
                if (this.multipleMode === false) {
                    this.$emit('filter-changed', this.property.id, this.checkedPropertyValues)
                }
            },
            turnMultipleMode() {
                this.$emit('update:multipleModeProperty', this.property);
                this.$emit('update:multipleMode', true);
            },
            cancelMultipleMode() {

                this.checkedPropertyValues = [];

                this.$emit('update:multipleModeProperty', {});
                this.$emit('update:multipleMode', false);
            },
            clear() {
                this.checkedPropertyValues = [];
                this.$emit('filter-changed', this.property.id, this.checkedPropertyValues)
            },
            acceptMultipleMode() {
                this.$emit('update:multipleModeProperty', {});
                this.$emit('update:multipleMode', false);

                this.$emit('filter-changed', this.property.id, this.checkedPropertyValues)
            }
        }
    }
</script>

<style scoped>
    .tm-disabled {
        color: #999;
    }
</style>


// WEBPACK FOOTER //
// FilterRow.vue?21db563e